export default "__VITE_ASSET__DqKfXHc6__"